import request from "@/utils/request";

//获取渠道订单
export async function GetChannelOrderList(data) {
  return request({
    url: "/Order/GetChannelOrderList",
    method: "post",
    data: data,
  });
}

//获取渠道结算汇总列表
export async function GetChSettlementList(data) {
  return request({
    url: "/Order/GetChSettlementList",
    method: "post",
    data: data,
  });
}

//导出结算汇总
export async function DownLoadChSettle(data) {
  return request({
    url: "/Order/DownLoadChSettle",
    method: "post",
    data: data,
  });
}

//获取渠道结算明细列表
export async function GetChSettlementDetailList(data) {
  return request({
    url: "/Order/GetChSettlementDetailList",
    method: "post",
    data: data,
  });
}

//导出渠道结算明细列表
export async function DownLoadChSettleDetail(data) {
  return request({
    url: "/Order/DownLoadChSettleDetail",
    method: "post",
    data: data,
  });
}

//结算打款详情
export async function GetPaySettleOK(data) {
  return request({
    url: "/Order/GetPaySettleOK",
    method: "get",
    params: data,
  });
}
